import React from 'react';
import { AppConfigProvider } from './AppConfig';
import type { AppProps } from './AppProps';
import { FavoriteHeartProvider } from './components/results/FavoriteHeart';
import { FeatureTogglesProvider } from './components/useFeatureToggles';
import { QueryErrorBoundary } from './data/QueryErrorBoundary';
import { AppStateProvider } from './state/AppState';

// Import Warp web component definitions, both for server-side and client-side
// rendering.
import '@warp-ds/elements/components/toast';

export function App(props: React.PropsWithChildren<AppProps>) {
    const { children, featureToggles, ...appConfig } = props;

    return (
        <AppConfigProvider {...appConfig}>
            <AppStateProvider>
                <FeatureTogglesProvider featureToggles={featureToggles}>
                    <FavoriteHeartProvider>
                        <QueryErrorBoundary>{children}</QueryErrorBoundary>
                    </FavoriteHeartProvider>
                </FeatureTogglesProvider>
            </AppStateProvider>
        </AppConfigProvider>
    );
}
